/**
 * @generated SignedSource<<244bda9d77c4615def03aa90de2151c4>>
 * @relayHash 52fc6bf3a35f313b17352fa2d80f0477
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/573.0.0-2026-08-18T15:46:00.033Z/HpSharedItemsGridTrendingSeedQuery

import { ConcreteRequest } from 'relay-runtime';
export type HpSharedItemsGridTrendingSeedQuery$variables = Record<PropertyKey, never>;
export type HpSharedItemsGridTrendingSeedQuery$data = {
  readonly viewer: {
    readonly itemSearchTrendingItems: {
      readonly itemIds: ReadonlyArray<string | null> | null;
    } | null;
  };
};
export type HpSharedItemsGridTrendingSeedQuery = {
  response: HpSharedItemsGridTrendingSeedQuery$data;
  variables: HpSharedItemsGridTrendingSeedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "sellerVerticals",
      "value": [
        "jewelry",
        "furniture",
        "fashion",
        "art"
      ]
    }
  ],
  "concreteType": "ItemSearchTrendingItemsResult",
  "kind": "LinkedField",
  "name": "itemSearchTrendingItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemIds",
      "storageKey": null
    }
  ],
  "storageKey": "itemSearchTrendingItems(sellerVerticals:[\"jewelry\",\"furniture\",\"fashion\",\"art\"])"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HpSharedItemsGridTrendingSeedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HpSharedItemsGridTrendingSeedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/573.0.0-2026-08-18T15:46:00.033Z/HpSharedItemsGridTrendingSeedQuery",
    "metadata": {},
    "name": "HpSharedItemsGridTrendingSeedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc81aa16a718d13e21b559a92765d669";

export default node;
